webpackJsonp([0,2],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1);
	
	console.log('hello');

/***/ },
/* 1 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"container","sectionContainer":"sectionContainer","headerContainer":"headerContainer","header":"header","subheader":"subheader","headerClapping":"headerClapping","clappingAnimation":"clappingAnimation","infoContainer":"infoContainer","infoHeader":"infoHeader","infoList":"infoList","infoListItem":"infoListItem","link":"link","taco":"taco","tacoAnimation":"tacoAnimation","infoUrl":"infoUrl"};

/***/ }
]);


/** WEBPACK FOOTER **
 ** app.7bb6cb85d17060172dcd.js
 **/